import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Invalid: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fill="#B3B3B3"
            fillRule="evenodd"
            d="M8,13.6 C4.913,13.6 2.4,11.087 2.4,8 C2.4,4.913 4.913,2.4 8,2.4 C11.087,2.4 13.6,4.913 13.6,8 C13.6,11.087 11.087,13.6 8,13.6 M8,1 C4.13400675,1 1,4.13400675 1,8 C1,9.85651543 1.73749788,11.6369928 3.05025253,12.9497475 C4.36300718,14.2625021 6.14348457,15 8,15 C9.85651543,15 11.6369928,14.2625021 12.9497475,12.9497475 C14.2625021,11.6369928 15,9.85651543 15,8 C15,6.14348457 14.2625021,4.36300718 12.9497475,3.05025253 C11.6369928,1.73749788 9.85651543,1 8,1 M4.5,8.7 L11.5,8.7 L11.5,7.3 L4.5,7.3"
        />
    </SvgIcon>
);

export default Invalid;
